module.exports = __webpack_public_path__ + "media/images/event-hero-bg-3c0b747ca33917376df718b6dc356f38.svg";